import { List, Map } from 'immutable';
import React from 'react';
import styled from '@emotion/styled';
import { EmbedType } from '~/types/models';
import useEmbeddedItemsInfo, {
  ColoredIconWrapper,
  TransparentIconWrapper,
} from '../../hooks/useEmbeddedItemsInfo';

interface EmbedPreviewsProps {
  embeds: List<Map<string, string>>;
  className?: string;
}

const StyledWrapper = styled.div`
  padding-bottom: 30px;
`;

const StyledEmbedItem = styled.div`
  width: 100%;
  height: 210px;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  ${ColoredIconWrapper},
  ${TransparentIconWrapper} {
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto 15px;
  }
`;

const StyledName = styled.p`
  font-size: 14px;
  margin-bottom: 0;
  color: #7d7c7c;
`;

const EmbedPreviews = (props: EmbedPreviewsProps) => {
  const { embeds, className } = props;

  const { getIcon } = useEmbeddedItemsInfo();

  return (
    <StyledWrapper className={className}>
      {embeds
        .map((item, index) => {
          return (
            <StyledEmbedItem key={index}>
              <div>
                {getIcon(
                  item?.get('icon') as string,
                  item?.get('type') as EmbedType
                )}
                <StyledName>{item?.get('title')}</StyledName>
              </div>
            </StyledEmbedItem>
          );
        })
        .toArray()}
    </StyledWrapper>
  );
};

export default EmbedPreviews;
